import { AddOnDetail } from './add-on-detail';

export class DropOffTask {
  type = 'dropoff';
  taskIds: string[];
  assignTo: string;
  passengers: string[];
  addOnDetails: AddOnDetail[];
  driverNotes: string;
}
